import { useDispatch, useSelector } from 'react-redux';

import { resetParams } from 'dpl/actions/query_params';
import { BUYER_PROFILE_MODAL_OPEN } from 'dpl/constants/query_params';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { singleBreederProfileResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

import useBuyerProfileQuizContext from './useBuyerProfileQuizContext';

export default function useBuyerProfileQuiz() {
  const dispatch = useDispatch();
  const queryParams = useSelector(state => state.queryParams);
  const context = useBuyerProfileQuizContext();

  const {
    onClose,
    isExpMiniAppEngagementVariantEnabled,
    breederProfileId,
    puppyName
  } = context;

  const conversationId =
    context.conversationId ?? queryParams[BUYER_PROFILE_MODAL_OPEN];

  const { value: breederProfile, isFetching: isFetchingBreederProfileData } =
    useResourceQuery({
      ...singleBreederProfileResourceDefinition(breederProfileId),
      enabled: Boolean(breederProfileId)
    });

  const isFetching = Boolean(isFetchingBreederProfileData);

  const isModalOpen = Boolean(conversationId);

  function closeModal() {
    if (typeof onClose === 'function') {
      onClose();
    } else {
      const otherParams = [];

      dispatch(resetParams(BUYER_PROFILE_MODAL_OPEN, ...otherParams));
    }
  }

  return {
    conversationId,
    breederProfile,
    puppyName,
    isFetching,
    isModalOpen,
    closeModal,
    isExpMiniAppEngagementVariantEnabled
  };
}
